import React from "react";
import { Col, Row } from "react-bootstrap";

import { useBackendPlatform } from "hooks";
import { ProgramDataType } from "types";
import { BackEndPlatformTypes, FrontEndPlatformTypes } from "types/enums";

import TextBlock from "../components/textBlock";

type ProgramViewProps = {
	data: ProgramDataType;
	displayFrontEndPlatform: boolean;
};

const ProgramView = ({ data, displayFrontEndPlatform }: ProgramViewProps) => {
	const {
		backEndPlatform,
		omahaFrontEndPlatform,
		northFrontEndPlatform,
		nashvilleFrontEndPlatform,
		compassFrontEndPlatform,
		buypassFrontEndPlatform,
		otherFrontEndPlatform,
		otherBackEndPlatformName,
		otherFrontEndPlatformName,
	} = data || {};

	const { isBackEndPlatformOther } = useBackendPlatform(backEndPlatform);

	return (
		<>
			<TextBlock label="Platform Information" isNoColon />
			<TextBlock
				label="Back End Platform"
				value={
					BackEndPlatformTypes.getByName(backEndPlatform)
						?.displayName || ""
				}
				dataAutotest="backendPlatform"
			/>
			{isBackEndPlatformOther && (
				<TextBlock
					label="Name"
					value={otherBackEndPlatformName}
					dataAutotest="otherBackendPlatformName"
				/>
			)}
			{displayFrontEndPlatform && (
				<>
					<TextBlock label="Front End Platform" />
					<Row>
						{omahaFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									iconCheck
									value={
										FrontEndPlatformTypes.Omaha.displayName
									}
									dataAutotest="frontendPlatform1"
								/>
							</Col>
						)}
						{northFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									iconCheck
									value={
										FrontEndPlatformTypes.North.displayName
									}
									dataAutotest="frontendPlatform2"
								/>
							</Col>
						)}
						{nashvilleFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									iconCheck
									value={
										FrontEndPlatformTypes.Nashville
											.displayName
									}
									dataAutotest="frontendPlatform3"
								/>
							</Col>
						)}
						{compassFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									iconCheck
									value={
										FrontEndPlatformTypes.Compass
											.displayName
									}
									dataAutotest="frontendPlatform4"
								/>
							</Col>
						)}
						{buypassFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									iconCheck
									value={
										FrontEndPlatformTypes.BuyPass
											.displayName
									}
									dataAutotest="frontendPlatform5"
								/>
							</Col>
						)}
						{otherFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									iconCheck
									value={
										FrontEndPlatformTypes.Other.displayName
									}
									dataAutotest="frontendPlatform6"
								/>
							</Col>
						)}
						{otherFrontEndPlatform && (
							<Col className="min-width-120" md={4} xl={1}>
								<TextBlock
									label="Name"
									value={otherFrontEndPlatformName}
									dataAutotest="otherFrontendPlatformName"
								/>
							</Col>
						)}
					</Row>
				</>
			)}
		</>
	);
};

export default ProgramView;
